import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { selectDashboardMenu } from "DashboardMenuAction";
import LocaleStrings from "Languages";

class UserlimitExpired extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var menuItem = {
            iconName: "UserLimit Expired",
            bsClass: "userlimitexpired",
            description: "Your User Limit has expired!",
        };
        this.props.selectDashboardMenu(menuItem);
    }

    requestTopup = () => {
        var menuItem = {
            iconName: "Account Settings",
            bsClass: "accountsettings",
            description: "Account Detailed Settings",
        };
        this.props.selectDashboardMenu(menuItem);
        this.props.history.push("/dashboard/accountsettings/billings");
    };
    goback = () => {
        this.props.history.push('/dashboard');
    };

    render() {
        let { total_accountusageCount, user } = this.props;
        let exceededby = parseInt(user.userlimit) - parseInt(total_accountusageCount.count);
        return (
            <div className="no-content-container">
                <div className="no-content-message">
                    <div >
                        <h4 className="custom-text1-primary-medium">{LocaleStrings.userlimit_exceed_head}</h4>
                        <h4 className="mt-4 custom-text1-primary-medium">{LocaleStrings.userlimit_exceed_userslimit} {user.userlimit} {LocaleStrings.userlimit_exceededuser}</h4>
                        <h4 className="mt-4 custom-text1-primary-medium">{LocaleStrings.userlimit_totalactiveusers} {total_accountusageCount.count} {LocaleStrings.userlimit_exceededuser}</h4>
                        <h4 className="mt-4 text-danger">{LocaleStrings.userlimit_exceedby} {exceededby} {LocaleStrings.userlimit_exceededuser}</h4>
                        <h4 className="mt-4 custom-text1-primary-medium">{LocaleStrings.userlimit_topupplan}</h4>
                        <div className="d-flex mt-4" style={{ justifyContent: 'center' }}>
                            <Button
                                className="btn-custom-blue schedule-add-button"
                                onClick={() => this.goback()}
                                style={{ marginLeft: "15px" }}
                            >
                                {LocaleStrings.userlimit_exceededbtnback}
                            </Button>
                            <Button
                                className="btn-custom-blue schedule-add-button"

                                onClick={() => this.requestTopup()}
                                style={{ marginLeft: "15px" }}
                            >
                                {LocaleStrings.userlimit_exceededbtnrequest}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        session: state.session,
        user: state.user,
        total_accountusageCount: state.total_accountusageCount

    };
}

export default connect(mapStateToProps, { selectDashboardMenu })(UserlimitExpired);
